import {METRICA} from '../../yango/production/metrica'
import {API_PASSPORT} from './api-passport'
import {AVATARS} from './avatars'
import {RUM} from './rum'
import {S3} from './s3'
import {YA_AUTHPROXY} from './ya-authproxy'

export const PRODUCTION = {
  METRICA,
  AVATARS,
  RUM,
  S3,
  YA_AUTHPROXY,
  API_PASSPORT,
}
